import React__default from 'react';
import { Context } from '@grandvisionhq/carts-v2';
import { toast } from '@grandvisionhq/common';
import { useIntl, useSelector } from '@grandvisionhq/state';
import { getSelectedPickupPoint, getSelectedStore } from '../../../../../StepShipping/selectors.js';
import { mapApplePayContactAddress } from '../mappers/apple-pay-contact-address.js';
import { mapAndMergeApplePayShippingContactWithBillingContact } from '../mappers/merge-apple-pay-contact-and-billing-address.js';
import { ApplePaySessionErrors } from '../../../../../mappers/errors-mapping.js';
import { isNearestPickup, isPickupPoint, isPickupStore } from '../../../../../utils/shipping-method.js';

const useMapShippingAddress = ()=>{
    const { country , getLabel  } = useIntl();
    const { cart  } = Context.useCart();
    const selectedPickupPoint = useSelector(getSelectedPickupPoint);
    const selectedStore = useSelector(getSelectedStore);
    return React__default.useCallback((applePayment)=>{
        // A billing address is always required
        if (!applePayment.billingContact) {
            return;
        }
        const isNearestPickup$1 = isNearestPickup(cart === null || cart === void 0 ? void 0 : cart.shippingMethod.key);
        const isPickupPoint$1 = isPickupPoint(cart === null || cart === void 0 ? void 0 : cart.shippingMethod.key);
        const isStorePickUp = isPickupStore(cart === null || cart === void 0 ? void 0 : cart.shippingMethod.key);
        if (isNearestPickup$1) {
            if (applePayment.billingContact.countryCode !== country) {
                toast.failed(ApplePaySessionErrors.ApplePayInvalidAddress);
                throw getLabel(ApplePaySessionErrors.ApplePayInvalidAddress);
            }
            return mapApplePayContactAddress(applePayment.billingContact);
        }
        // Only in the case of isNearestPickup a shipping address is optional
        if (!(applePayment === null || applePayment === void 0 ? void 0 : applePayment.shippingContact)) {
            return;
        }
        if (isPickupPoint$1) {
            const mappedAndMergedShippingAddress = mapAndMergeApplePayShippingContactWithBillingContact(applePayment.shippingContact, applePayment.billingContact);
            if (mappedAndMergedShippingAddress && !!(selectedPickupPoint === null || selectedPickupPoint === void 0 ? void 0 : selectedPickupPoint.globalPickupPointId)) {
                mappedAndMergedShippingAddress.externalId = selectedPickupPoint === null || selectedPickupPoint === void 0 ? void 0 : selectedPickupPoint.globalPickupPointId;
            }
            // Apple Pay doesn't provide a company field.
            mappedAndMergedShippingAddress.company = selectedPickupPoint === null || selectedPickupPoint === void 0 ? void 0 : selectedPickupPoint.name;
            return mappedAndMergedShippingAddress;
        }
        if (isStorePickUp) {
            const mappedAndMergedShippingAddress = mapAndMergeApplePayShippingContactWithBillingContact(applePayment.shippingContact, applePayment.billingContact);
            if (mappedAndMergedShippingAddress && !!(selectedStore === null || selectedStore === void 0 ? void 0 : selectedStore.code)) {
                mappedAndMergedShippingAddress.externalId = selectedStore === null || selectedStore === void 0 ? void 0 : selectedStore.code.toString();
            }
            // Apple Pay doesn't provide a company field.
            mappedAndMergedShippingAddress.company = selectedStore === null || selectedStore === void 0 ? void 0 : selectedStore.name;
            return mappedAndMergedShippingAddress;
        }
        // Default
        return mapApplePayContactAddress(applePayment === null || applePayment === void 0 ? void 0 : applePayment.shippingContact);
    }, [
        cart === null || cart === void 0 ? void 0 : cart.shippingMethod.key,
        country,
        getLabel,
        selectedPickupPoint === null || selectedPickupPoint === void 0 ? void 0 : selectedPickupPoint.globalPickupPointId,
        selectedPickupPoint === null || selectedPickupPoint === void 0 ? void 0 : selectedPickupPoint.name,
        selectedStore === null || selectedStore === void 0 ? void 0 : selectedStore.code,
        selectedStore === null || selectedStore === void 0 ? void 0 : selectedStore.name, 
    ]);
};

export { useMapShippingAddress };
//# sourceMappingURL=use-map-shipping-address.js.map
